import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromCore from './core.reducer';
import { State } from './core.reducer';

export const selectCoreState = createFeatureSelector<fromCore.State>(
  fromCore.coreFeatureKey
);

export const selectBreakpoint = createSelector(
  selectCoreState,
  (coreState: State) => {
    return coreState.breakpoint;
  }
);

export const selectElevatorIndex = createSelector(
  selectCoreState,
  (coreState: State) => {
    return coreState.elevatorIndex;
  }
);

export const selectElevatorRatio = createSelector(
  selectCoreState,
  (coreState: State) => {
    return coreState.elevatorRatio;
  }
);

export const selectPreferences = createSelector(
  selectCoreState,
  (coreState: State) => {
    return coreState.preferences;
  }
);

export const selectAppReady = createSelector(
  selectCoreState,
  (coreState: State) => {
    return coreState.appReady;
  }
);
